import React, { useContext } from "react";
import { useState, useEffect, useRef } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../../utils/context";
import JoditEditor from "jodit-react";

import Offcanvas from "react-bootstrap/Offcanvas";

import Card from "react-bootstrap/Card";
import Select from "react-select";
import ModalSave from "../../../common/ModalSave";
import Validation from "../../../common/FormValidation";
import { CancelButton, SaveButton } from "../../../common/Button";

import { Container, Row, Col, Button, Form, InputGroup } from "react-bootstrap";

const AddOffCanvance = (props) => {
  const { postData, getData } = useContext(Context);
  const editor = useRef(null);
  const [content, setContent] = useState("");
  const [room, setRoom] = useState([]);
  const [facilities, setFacilities] = useState([]);
  const [facilityOptions, setFacilityOptions] = useState([]);
  const [bedOptions, setBedOptions] = useState([]);
  const [bed, setBed] = useState([]);
  const [errors, setErrors] = useState();
  const [selectedFile, setSelectedFile] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    size: "",
    bed: null,
    capacity: null,
    view: "",
    price: "",
    facilities: "",
    description: "",
    image: "",
    images: "",
    rating: "",
  });
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const handleKeyPressContact = (event) => {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);

    if (!/^\d*\.?\d*$/.test(keyValue)) {
      event.preventDefault();
    }
  };

  const handleDescriptionChange = (value) => {
    setFormData({ ...formData, description: value });
  };

  const handleFacilityChange = (selectedFacilities) => {
    setFacilities(selectedFacilities);

    const facilityNames = selectedFacilities?.map(
      (facility) => facility?.label
    );
    setFormData({ ...formData, facilities: facilityNames });
  };
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setSelectedFile(file);
  };

  const handleChange = (e) => {
    if (e?.name === "room_id") {
      // Handle the case when the event comes from Select component
      setFormData((prevFormData) => ({
        ...prevFormData,
        [e.name]: e.value,
      }));
      getSelectedBed(e.value);
    } else {
      // Handle regular input fields
      setFormData((prevFormData) => ({
        ...prevFormData,
        [e.target.name]: e.target.value,
      }));
    }
  };

  const validateForm = () => {
    let errors = {};
    const regexNumeric = /^[0-9]+$/;
    const regexAlfaNumric = /^[A-Za-z0-9]+(\s[A-Za-z0-9]+)*$/;
    const regexAlfa = /^[A-Za-z]+(\s[A-Za-z]+)*$/;

    if (!formData.name) {
      errors.name = "Room name is required";
    }
    // else if (!regexAlfaNumric.test(formData.name?.trim())) {
    //   errors.name = "Enter a valid room name";
    // }

    if (!formData.image) {
      errors.image = "Image is required";
    }

    if (!formData.images) {
      errors.images = "Images are required";
    }

    if (!formData.size) {
      errors.size = "WashRoom is required";
    } else if (!regexNumeric.test(formData.size?.trim())) {
      errors.size = "Size must be a numeric value";
    }

    if (!formData.bed) {
      errors.bed = "Bed type is required";
    }

    if (!formData.capacity) {
      errors.capacity = "Capacity is required";
    } else if (!regexNumeric.test(formData.capacity?.trim())) {
      errors.capacity = "Capacity must be a numeric value";
    }

    if (!formData.view) {
      errors.view = "View is required";
    }

    if (!formData.price) {
      errors.price = "Price is required";
    } else if (!regexNumeric.test(formData.price?.trim())) {
      errors.price = "Price must be a numeric value";
    }

    if (!formData.facilities || formData.facilities.length === 0) {
      errors.facilities = "Facilities are required";
    }

    if (!formData.description) {
      errors.description = "Description is required";
    }

    // Add more validations as needed

    return errors;
  };

  const errorStyle = {
    color: "red",
    marginLeft: "5px",
    // fontSize: "11px",
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validateForm();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      try {
        const finalData = new FormData();
        finalData.append("name", formData.name);
        finalData.append("size", formData.size);
        finalData.append("bed", formData.bed);
        finalData.append("capacity", formData.capacity);
        finalData.append("view", formData.view);
        finalData.append("price", formData.price);
        finalData.append("description", content);
        finalData.append("facilities", JSON.stringify(facilities));
        finalData.append("image", formData.image);
        finalData.append("rating", formData.rating);

        if (formData.images) {
          for (let i = 0; i < formData.images.length; i++) {
            finalData.append(`images[${i}]`, formData.images[i]);
          }
        }
        console.log("finalData :-", finalData);
        const response = await postData("/masters/room", finalData);

        if (response?.success) {
          setShowModal({ code: response?.code, message: response?.message });
          setTimeout(() => {
            setShowModal(0);
            props.handleClose();
          }, 1000);
        } else {
          setShowModal({ code: response?.code, message: response?.message });
          setTimeout(() => {
            setShowModal(0);
            props.handleClose();
          }, 1000);
        }
      } catch (error) {
        console.error("Error submitting form:", error);
      }
    }
  };

  async function getSelectedBed(id) {
    const response = await getData(`/allbed/${id}`);

    if (response.success) {
      setBed(response.data);
    }
  }

  const GetAllRoom = async () => {
    const response = await getData("/allroom");

    const option = [];
    if (response?.success) {
      response?.data?.map((data) => {
        option.push({
          value: data.id,
          label: data.name,
        });
      });
    }
    setRoom(option);
  };

  const fetchFacilities = async () => {
    try {
      const response = await getData("/masters/facilities");

      if (response?.success) {
        const facilitiesData = response.data.data;

        if (Array.isArray(facilitiesData)) {
          const options = facilitiesData?.map((facility) => ({
            value: facility?.id,
            label: facility?.name,
          }));
          setFacilityOptions(options);
        } else {
          console.error(
            "Invalid data format for facilities. Expected an array."
          );
        }
      }
    } catch (error) {
      console.error("Error fetching facilities:", error);
    }
  };

  const GetAllBeds = async () => {
    const response = await getData("/allbed");

    const option = [];
    if (response?.success) {
      response?.data?.map((data) => {
        option.push({
          value: data.id,
          label: data.name,
        });
      });
    }
    setBedOptions(option);
  };

  useEffect(() => {
    GetAllRoom();
  }, []);
  useEffect(() => {
    fetchFacilities();
  }, []);
  useEffect(() => {
    GetAllBeds(); // Fetch bed options when the component mounts
  }, []);

  return (
    <>
      <Offcanvas
        show={props.show}
        style={{ width: "80%" }}
        placement={"end"}
        onHide={props.handleClose}
      >
        <Offcanvas.Header closeButton>
          {/* <Offcanvas.Title>Add State</Offcanvas.Title> */}
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Card className="shadow-lg p-3 mb-5 bg-white rounded">
            <Card.Body>
              <Card.Title>Add Rooms</Card.Title>
              <hr />
              <Container>
                <Row>
                  <Col md={12}>
                    <Container>
                      <Row className="">
                        <Col xxl={12} xl={12} md={10}>
                          <Form
                            onSubmit={handleSubmit}
                            role="form"
                            className="roomclass"
                          >
                            <Row>
                              <Col md={5}>
                                <div className="main-form-section mt-2">
                                  <Row className="justify-content-center">
                                    <Form.Label column sm={3}>
                                      Room
                                    </Form.Label>
                                    <Col sm={6}>
                                      <Form.Group>
                                        <InputGroup>
                                          <Form.Control
                                            type="text"
                                            name="name"
                                            value={formData.name}
                                            onChange={handleChange}
                                            placeholder="Room "
                                            id="inputEmail3"
                                            className="input-mandatory"
                                          />
                                        </InputGroup>
                                        {errors?.name && (
                                          <span style={errorStyle}>
                                            {errors?.name}
                                          </span>
                                        )}
                                      </Form.Group>
                                    </Col>
                                  </Row>
                                </div>

                                <div className="main-form-section mt-2">
                                  <Row className="justify-content-center">
                                    <Form.Label column sm={3}>
                                      WashRoom
                                    </Form.Label>
                                    <Col sm={6}>
                                      <Form.Group>
                                        <InputGroup>
                                          <Form.Control
                                            type="text"
                                            name="size"
                                            value={formData.size}
                                            onKeyPress={handleKeyPressContact}
                                            onChange={handleChange}
                                            placeholder="WashRoom "
                                            id="inputEmail3"
                                            className="input-mandatory"
                                          />
                                        </InputGroup>
                                        {errors?.size && (
                                          <span style={errorStyle}>
                                            {errors?.size}
                                          </span>
                                        )}
                                      </Form.Group>
                                    </Col>
                                  </Row>
                                </div>

                                <div className="main-form-section mt-2">
                                  <Row className="justify-content-center">
                                    <Form.Label column sm={3}>
                                      Bed
                                    </Form.Label>
                                    <Col sm={6}>
                                      <Form.Group>
                                        <Select
                                          options={bedOptions}
                                          value={bedOptions.find(
                                            (bed) => bed.value === formData.bed
                                          )}
                                          onChange={(selectedBed) =>
                                            setFormData({
                                              ...formData,
                                              bed: selectedBed?.value || null,
                                            })
                                          }
                                        />
                                        {errors?.bed && (
                                          <span style={errorStyle}>
                                            {errors?.bed}
                                          </span>
                                        )}
                                      </Form.Group>
                                    </Col>
                                  </Row>
                                </div>

                                <div className="main-form-section mt-2">
                                  <Row className="justify-content-center">
                                    <Form.Label column sm={3}>
                                      Capacity
                                    </Form.Label>
                                    <Col sm={6}>
                                      <Form.Group>
                                        <InputGroup>
                                          <Form.Control
                                            type="tel"
                                            name="capacity"
                                            value={formData.capacity}
                                            onKeyPress={handleKeyPressContact}
                                            onChange={handleChange}
                                            placeholder="capacity "
                                            id="inputEmail3"
                                            className="input-mandatory"
                                          />
                                        </InputGroup>
                                        {errors?.capacity && (
                                          <span style={errorStyle}>
                                            {errors?.capacity}
                                          </span>
                                        )}
                                      </Form.Group>
                                    </Col>
                                  </Row>
                                </div>

                                <div className="main-form-section mt-2">
                                  <Row className="justify-content-center">
                                    <Form.Label column sm={3}>
                                      View
                                    </Form.Label>
                                    <Col sm={6}>
                                      <Form.Group>
                                        <InputGroup>
                                          <Form.Control
                                            type="text"
                                            name="view"
                                            value={formData.view}
                                            onChange={handleChange}
                                            placeholder="view "
                                            id="inputEmail3"
                                            className="input-mandatory"
                                          />
                                        </InputGroup>
                                        {errors?.view && (
                                          <span style={errorStyle}>
                                            {errors?.view}
                                          </span>
                                        )}
                                      </Form.Group>
                                    </Col>
                                  </Row>
                                </div>

                                <div className="main-form-section mt-2">
                                  <Row className="justify-content-center">
                                    <Form.Label column sm={3}>
                                      Rating
                                    </Form.Label>
                                    <Col sm={6}>
                                      <Form.Group>
                                        <InputGroup>
                                          <Form.Control
                                            as="select"
                                            name="rating"
                                            value={formData.rating}
                                            onChange={handleChange}
                                            className="input-mandatory"
                                          >
                                            <option value="">
                                              Select Rating
                                            </option>
                                            {[1, 2, 3, 4, 5].map((value) => (
                                              <option key={value} value={value}>
                                                {value}
                                              </option>
                                            ))}
                                          </Form.Control>
                                        </InputGroup>
                                        <span className="error-message"></span>
                                      </Form.Group>
                                    </Col>
                                  </Row>
                                </div>
                              </Col>

                              <Col md={6}>
                                <div className="main-form-section mt-2">
                                  <Row className="justify-content-center">
                                    <Form.Label column sm={3}>
                                      price
                                    </Form.Label>
                                    <Col sm={6}>
                                      <Form.Group>
                                        <InputGroup>
                                          <Form.Control
                                            type="text"
                                            name="price"
                                            onKeyPress={handleKeyPressContact}
                                            value={formData.price}
                                            onChange={handleChange}
                                            placeholder="price / night "
                                            id="inputEmail3"
                                            className="input-mandatory"
                                          />
                                        </InputGroup>
                                        {errors?.price && (
                                          <span style={errorStyle}>
                                            {errors?.price}
                                          </span>
                                        )}
                                      </Form.Group>
                                    </Col>
                                  </Row>
                                </div>

                                <div className="main-form-section mt-2">
                                  <Row className="justify-content-center">
                                    <Form.Label column sm={3}>
                                      Facilities
                                    </Form.Label>
                                    <Col sm={6}>
                                      <Form.Group>
                                        <Select
                                          options={facilityOptions}
                                          isMulti
                                          value={facilities?.id}
                                          onChange={handleFacilityChange}
                                        />
                                        {errors?.facilities && (
                                          <span style={errorStyle}>
                                            {errors?.facilities}
                                          </span>
                                        )}
                                      </Form.Group>
                                    </Col>
                                  </Row>
                                </div>

                                <div className="main-form-section mt-2">
                                  <Row className="justify-content-center">
                                    <Form.Label column sm={3}>
                                      Image
                                    </Form.Label>

                                    <Col sm={6}>
                                      <Form.Group>
                                        <InputGroup>
                                          <Form.Control
                                            type="file"
                                            name="image"
                                            accept="image/*"
                                            onChange={(e) => {
                                              setFormData({
                                                ...formData,
                                                [e.target.name]:
                                                  e.target.files[0],
                                              });
                                            }}
                                          />
                                        </InputGroup>
                                        {errors?.image && (
                                          <span style={errorStyle}>
                                            {errors?.image}
                                          </span>
                                        )}
                                      </Form.Group>
                                    </Col>
                                  </Row>
                                </div>

                                <div className="main-form-section mt-2">
                                  <Row className="justify-content-center">
                                    <Form.Label column sm={3}>
                                      images
                                    </Form.Label>

                                    <Col sm={6}>
                                      <Form.Group>
                                        <InputGroup>
                                          <Form.Control
                                            type="file"
                                            name="images"
                                            accept="image/*"
                                            onChange={(e) => {
                                              setFormData({
                                                ...formData,
                                                [e.target.name]: e.target.files,
                                              });
                                            }}
                                            multiple
                                          />
                                        </InputGroup>
                                        {errors?.images && (
                                          <span style={errorStyle}>
                                            {errors?.images}
                                          </span>
                                        )}
                                      </Form.Group>
                                    </Col>
                                  </Row>
                                </div>

                                <div
                                  className="main-form-section mt-2"
                                  style={{ width: "100%", maxWidth: "800px" }}
                                >
                                  <Row className="justify-content-center">
                                    <Form.Label column sm={3}>
                                      Description
                                    </Form.Label>
                                    <Col sm={9}>
                                      <Form.Group>
                                        <InputGroup>
                                          <JoditEditor
                                            ref={editor}
                                            value={content}
                                            // config={config}
                                            tabIndex={1} // tabIndex of textarea
                                            onBlur={(newContent) =>
                                              setContent(newContent)
                                            }
                                            onChange={handleDescriptionChange}
                                          />
                                        </InputGroup>
                                        {errors?.description && (
                                          <span style={errorStyle}>
                                            {errors?.description}
                                          </span>
                                        )}
                                      </Form.Group>
                                    </Col>
                                  </Row>
                                </div>
                              </Col>

                              {/* </Row> */}

                              <Row className="mt-5 pb-3">
                                <div className="d-flex justify-content-center">
                                  <Link>
                                    <CancelButton
                                      name={"cancel"}
                                      handleClose={props.handleClose}
                                    />
                                  </Link>
                                  <SaveButton
                                    name={"save"}
                                    handleSubmit={handleSubmit}
                                  />
                                </div>
                              </Row>
                            </Row>
                          </Form>
                        </Col>
                      </Row>
                    </Container>
                  </Col>
                </Row>
              </Container>
            </Card.Body>
          </Card>
        </Offcanvas.Body>
      </Offcanvas>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default AddOffCanvance;
